import { render, staticRenderFns } from "./ProductMaster.vue?vue&type=template&id=a60cb3fa&"
import script from "./ProductMaster.vue?vue&type=script&lang=js&"
export * from "./ProductMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductMaster.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports